import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable';
const DistrictWiseReport = Loadable(lazy(() => import("./DistrictWiseReport")));


const DistrictWiseReportRoutes = [
    {
        path: '/DistrictWiseReport',
        element: <DistrictWiseReport />,
    },
]

export default DistrictWiseReportRoutes